// pages/UploadPage.js
import React, { useState, useEffect } from 'react';
import { uploadMovie, fetchCategories } from '../api'; // 假设有一个fetchCategories函数

function UploadPage() {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    recommendedReason: '', // 添加推荐理由
    video: null,
  });
  const [categories, setCategories] = useState([]); // 存储获取到的类别列表
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({ ...prevData, video: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataCopy = new FormData();
    formDataCopy.append('title', formData.title);
    formDataCopy.append('description', formData.description);
    formDataCopy.append('category', formData.category);
    formDataCopy.append('recommendedReason', formData.recommendedReason);
    formDataCopy.append('video', formData.video);

    try {
      await uploadMovie(formDataCopy);
      alert('Video uploaded successfully!');
      setFormData({ title: '', description: '', category: '', recommendedReason: '', video: null });
    } catch (error) {
      console.error('Error uploading video:', error);
      alert('Failed to upload video.');
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px', border: '1px solid #ccc', borderRadius: '5px' }}>
      <h2>Upload Video</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <input 
          type="text" 
          name="title" 
          value={formData.title} 
          onChange={handleChange} 
          placeholder="Title" 
          required 
          style={{ padding: '8px', borderRadius: '4px' }}
        />
        <textarea 
          name="description" 
          value={formData.description} 
          onChange={handleChange} 
          placeholder="Description" 
          required 
          style={{ padding: '8px', borderRadius: '4px', minHeight: '100px' }}
        />
        <select 
          name="category" 
          value={formData.category} 
          onChange={handleChange} 
          required
          style={{ padding: '8px', borderRadius: '4px' }}
        >
          <option value="">Select a category</option>
          {/* 动态生成选项 */}
          {categories.map(category => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
        <input 
          type="text" 
          name="recommendedReason" 
          value={formData.recommendedReason} 
          onChange={handleChange} 
          placeholder="Recommended Reason" 
          required 
          style={{ padding: '8px', borderRadius: '4px' }}
        />
        <input 
          type="file" 
          onChange={handleFileChange} 
          required 
          style={{ padding: '8px', borderRadius: '4px' }}
        />
        <button type="submit" style={{ padding: '8px 16px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}>
          Upload
        </button>
      </form>
    </div>
  );
}

export default UploadPage;